import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import ReportCard from "./ReportCard";
import WeeklyRollsReport from "./WeeklyRollsReport";

/**
 * Reports — a list of standing reports, each opened on demand.
 *
 * One card per report so the page stays a menu as more are added, rather than
 * a single page that has to be redesigned each time.
 */
const ReportsPage: React.FC = () => (
  <Box sx={{ p: { xs: 0, sm: 1 } }}>
    <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
      Reports
    </Typography>

    <Stack spacing={2}>
      <ReportCard
        title="Weekly Rolls Produced — by Quarter"
        description="A and B rolls by week, per line and totalled, to read beside the scorecard. Opens on the current quarter; pick an earlier one to look back."
        defaultOpen
      >
        <WeeklyRollsReport />
      </ReportCard>
    </Stack>
  </Box>
);

export default ReportsPage;
